'use client';

import { useEffect, useState } from 'react';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)'); // Define your mobile breakpoint

    const handleResize = () => {
      setIsMobile(mediaQuery.matches);
    };

    // Initial check
    handleResize();

    // Add listener for changes in screen size
    mediaQuery.addListener(handleResize);

    // Cleanup
    return () => {
      mediaQuery.removeListener(handleResize);
    };
  }, []);

  return isMobile;
}
